import { Box, Button, Flex, FormControl, Input, Radio, RadioGroup, Text } from "@chakra-ui/react";

import { useEffect, useState } from "react";

const getLocalDateString = (date = new Date()) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export default function JobSearchForm({
  onSearch,
  onValueChange,
  onSearchByChange,
  onFromDateChange,
  onToDateChange,
} = {}) {
  const [searchBy, setSearchBy] = useState("serial");
  const [searchValue, setSearchValue] = useState("");
  const [dateFrom, setDateFrom] = useState(() => getLocalDateString());
  const [dateTo, setDateTo] = useState(() => getLocalDateString());

  const handleRadioChange = (value) => {
    setSearchBy(value);
    if (onValueChange) onValueChange("");
    setSearchValue("");
    if (onSearchByChange) onSearchByChange(value);
  };

  useEffect(() => {
    if (onValueChange) onValueChange(searchValue);
  }, [searchValue, onValueChange]);

  return (
    <Box
      maxW={{ base: "100%", md: "5xl" }}
      mx='auto'
      px={{ base: "2", md: "6", lg: "2" }}
      py={{ base: "2", md: "4", lg: "6" }}
      w={{ base: "95vw", md: "auto" }}
      borderWidth={1}
      borderRadius='md'
    >
      <FormControl id='serialNumber'>
        <RadioGroup defaultValue='serial' value={searchBy}>
          <Flex
            direction={{ base: "column", md: "row" }}
            spacing={{ base: 2, md: 4 }}
            justify='center'
            align={{ base: "stretch", md: "center" }}
          >
            <Radio
              w={{ base: "100%", md: "auto" }}
              flex={{ base: "1", md: "1" }}
              minW={{ base: "auto", md: "250px" }}
              mb={{ base: "2", md: "0" }}
              value='serial'
              onChange={() => handleRadioChange("serial")}
            >
              By Serial Number
            </Radio>
            <Input
              flex={{ base: "1", md: "4" }}
              type='text'
              placeholder='Enter Serial Number'
              py={{ base: "2", md: "2" }}
              value={searchBy === "serial" ? searchValue : ""}
              onChange={(e) => setSearchValue(e.target.value)}
              onFocus={() => {
                setSearchValue("");
                setSearchBy("serial");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearch(searchBy, searchValue, dateFrom, dateTo);
                }
              }}
            />
          </Flex>
          <Flex
            direction={{ base: "column", md: "row" }}
            spacing={{ base: 2, md: 4 }}
            justify='center'
            align={{ base: "stretch", md: "center" }}
            mt={{ base: 3, md: 4 }}
          >
            <Radio
              w={{ base: "100%", md: "auto" }}
              flex={{ base: "1", md: "1" }}
              minW={{ base: "auto", md: "250px" }}
              mb={{ base: "2", md: "0" }}
              value='surname'
              onChange={() => handleRadioChange("surname")}
            >
              By Surname
            </Radio>
            <Input
              flex={{ base: "1", md: "4" }}
              type='text'
              placeholder='Enter Customer Surname (starts with...)'
              py={{ base: "2", md: "2" }}
              value={searchBy === "surname" ? searchValue : ""}
              onChange={(e) => setSearchValue(e.target.value)}
              onFocus={() => {
                setSearchValue("");
                setSearchBy("surname");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearch(searchBy, searchValue, dateFrom, dateTo);
                }
              }}
            />
          </Flex>
          <Flex
            direction={{ base: "column", md: "row" }}
            spacing={{ base: 2, md: 4 }}
            justify='center'
            align={{ base: "stretch", md: "center" }}
            mt={{ base: 3, md: 4 }}
          >
            <Radio
              w={{ base: "100%", md: "auto" }}
              flex={{ base: "1", md: "1" }}
              minW={{ base: "auto", md: "250px" }}
              mb={{ base: "2", md: "0" }}
              value='firstName'
              onChange={() => handleRadioChange("firstName")}
            >
              By First Name
            </Radio>
            <Input
              flex={{ base: "1", md: "4" }}
              type='text'
              placeholder='Enter Customer First Name (starts with...)'
              py={{ base: "2", md: "2" }}
              value={searchBy === "firstName" ? searchValue : ""}
              onChange={(e) => setSearchValue(e.target.value)}
              onFocus={() => {
                setSearchValue("");
                setSearchBy("firstName");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearch(searchBy, searchValue, dateFrom, dateTo);
                }
              }}
            />
          </Flex>
          <Flex
            direction={{ base: "column", md: "row" }}
            spacing={{ base: 2, md: 4 }}
            justify='center'
            align={{ base: "stretch", md: "center" }}
            mt={{ base: 3, md: 4 }}
          >
            <Radio
              w={{ base: "100%", md: "auto" }}
              flex={{ base: "1", md: "1" }}
              minW={{ base: "auto", md: "250px" }}
              mb={{ base: "2", md: "0" }}
              value='phoneNumber'
              onChange={() => handleRadioChange("phoneNumber")}
            >
              By Phone Number
            </Radio>
            <Input
              flex={{ base: "1", md: "4" }}
              type='text'
              placeholder='Enter Customer Phone Number'
              py={{ base: "2", md: "2" }}
              value={searchBy === "phoneNumber" ? searchValue : ""}
              onChange={(e) => setSearchValue(e.target.value)}
              onFocus={() => {
                setSearchValue("");
                setSearchBy("phoneNumber");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearch(searchBy, searchValue, dateFrom, dateTo);
                }
              }}
            />
          </Flex>
          <Flex
            direction={{ base: "column", md: "row" }}
            spacing={{ base: 2, md: 4 }}
            justify='center'
            align={{ base: "stretch", md: "center" }}
            mt={{ base: 3, md: 4 }}
          >
            <Radio
              w={{ base: "100%", md: "auto" }}
              flex={{ base: "1", md: "1" }}
              minW={{ base: "auto", md: "250px" }}
              mb={{ base: "2", md: "0" }}
              value='jobNumber'
              onChange={() => handleRadioChange("jobNumber")}
            >
              By Job Number
            </Radio>
            <Input
              flex={{ base: "1", md: "4" }}
              type='text'
              placeholder='Enter Job Number'
              py={{ base: "2", md: "2" }}
              value={searchBy === "jobNumber" ? searchValue : ""}
              onChange={(e) => setSearchValue(e.target.value)}
              onFocus={() => {
                setSearchValue("");
                setSearchBy("jobNumber");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearch(searchBy, searchValue, dateFrom, dateTo);
                }
              }}
            />
          </Flex>
          <Flex
            direction={{ base: "column", md: "row" }}
            spacing={{ base: 2, md: 4 }}
            justify='center'
            align={{ base: "stretch", md: "flex-start" }}
            mt={{ base: 3, md: 4 }}
          >
            <Radio
              w={{ base: "100%", md: "auto" }}
              flex={{ base: "1", md: "1" }}
              minW={{ base: "auto", md: "250px" }}
              mb={{ base: "2", md: "0" }}
              value='jobDate'
              onChange={() => handleRadioChange("jobDate")}
            >
              By Job Date
            </Radio>
            <Flex
              flex={{ base: "1", md: "4" }}
              //direction={{ base: "column", md: "row" }}
              gap={{ base: 2, md: 4 }}
              align={{ base: "stretch", md: "center" }}
              w={{ base: "100%", md: "auto" }}
            >
              <Flex align='center' gap='2' w='50%'>
                <Text fontSize='sm' color='gray.500' whiteSpace='nowrap'>
                  From:
                </Text>
                <Input
                  type='date'
                  placeholder='Enter Start Date'
                  flex={{ base: "1", md: "auto" }}
                  py={{ base: "2", md: "2" }}
                  value={searchBy === "jobDate" ? dateFrom : ""}
                  onChange={(e) => {
                    const date = e.target.value;
                    if (date) {
                      const localDate = new Date(date);
                      setDateFrom(getLocalDateString(localDate));
                    } else {
                      setDateFrom("");
                    }
                    if (onFromDateChange) onFromDateChange(date ? new Date(date).setHours(0, 0, 0, 0) : "");
                  }}
                  onFocus={() => setSearchBy("jobDate")}
                />
              </Flex>
              <Flex align='center' gap='2' w='50%'>
                <Text fontSize='sm' color='gray.500' whiteSpace='nowrap'>
                  To:
                </Text>
                <Input
                  type='date'
                  placeholder='Enter End Date'
                  flex={{ base: "1", md: "auto" }}
                  py={{ base: "2", md: "2" }}
                  value={searchBy === "jobDate" ? dateTo : ""}
                  onChange={(e) => {
                    const date = e.target.value;
                    if (date) {
                      const endOfDay = new Date(date);
                      endOfDay.setHours(23, 59, 59, 999);
                      setDateTo(getLocalDateString(endOfDay));
                      if (onToDateChange) onToDateChange(endOfDay.getTime());
                    } else {
                      setDateTo("");
                      if (onToDateChange) onToDateChange("");
                    }
                  }}
                  onFocus={() => setSearchBy("jobDate")}
                />
              </Flex>
            </Flex>
          </Flex>
        </RadioGroup>
        <Flex justify='center' mt={6}>
          <Button
            colorScheme='blue'
            justifySelf='center'
            onClick={() => onSearch(searchBy, searchValue, dateFrom, dateTo)}
            disabled={(searchBy !== "jobDate" && !searchValue) || (searchBy === "jobDate" && (!dateFrom || !dateTo))}
          >
            Search
          </Button>
        </Flex>
      </FormControl>
      <Text align='center' mt={8} fontSize='sm' color='gray.500'>
        {searchBy === "serial" && "Searches by Serial Number will return all jobs with an exact match."}
        {searchBy === "surname" &&
          "Searches by Surname will return all jobs where the customer's surname starts with the entered text."}
        {searchBy === "firstName" &&
          "Searches by First Name will return all jobs where the customer's first name starts with the entered text."}
        {searchBy === "phoneNumber" &&
          "Searches by Phone Number will return all jobs where the customer's phone number is an exact match."}
        {searchBy === "jobNumber" && "Searches by Job Number will return a job where the job number is an exact match."}
      </Text>
    </Box>
  );
}
